import React, { useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InputField from "../../components/Fields/inputFields";
import PrimaryButton from "../../components/Fields/primaryButton";
import Slider from "../../components/swiper/swiper";
import ReCAPTCHA from "react-google-recaptcha";
import logo from "../../../icons/myIcons/logo.png";
import { confirmPasswordValidation, passwordValidation, passwordValidationNew } from "../../../function/validation";
import PasswordField from "../../components/Fields/passwordField";
import { setPasswordForNewUser } from "../../../service/auth/setPasswordForNewUser";
import { useDispatch } from "react-redux";

function SetPasswordForNewUser() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code"); // Get the 'code' query parameter
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [loadingActive, setLoadingActive] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState("");
  const recaptchaRef = useRef();

  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const resetCaptcha = async () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  };

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);

    if (value !== password) {
      setConfirmPasswordError("Passwords do not match.");
    } else {
      setConfirmPasswordError("");
    }
  };
    const dispatch=useDispatch()
  function onSubmit(e) {
    // if(password.length<=12){
    //     toast.error("Password must be have minimum of 12 characters.")
    //     return
    // }
            if (
              !passwordValidation(password) ||
              !confirmPasswordValidation(password, confirmPassword)
            ) {
              if (!passwordValidation(password)) {
                setPasswordError(true);
              }
              if (!confirmPasswordValidation(password, confirmPassword)) {
                setConfirmPasswordError(true);
              }
            } else {
              var data = {
                "ResponseMessage": "",
                "ApiCallStatus": 0,
                "StatusCode": 0,
                "Message": "",
                "Email": "",
                "Password": password,
                "ConfirmPassword": confirmPassword,
                "Code": code
        };

        dispatch(
          setPasswordForNewUser(
            data,
            (res) => {
              setLoadingActive(false);  
              toast.success("New Password Added Successfully")    
              navigate("/")      
            },
            (err) => {
              setLoadingActive(false);
            }
          )
        );
            }
  }

  return (
    <>
      <ToastContainer />
      <div className=" " style={{ background: "#f1f1ff" }}>
        <div
          className="col-xl-12 "
          style={{
            height: "100dvh",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div className=" border-0 d-flex justify-content-center">
            <div className=" card login-bx" style={{ width: "80%" }}>
              <div className="row custome-row">
                <div
                  className="col-xl-6 col-md-6  text-center d-flex justify-content-center align-items-center "
                  style={{ borderRight: "1px solid lightgray" }}
                >
                  <Slider />
                </div>
                <div
                  className="col-xl-6 col-md-6  d-flex cutome-col align-items-center justify-content-center overflow-auto"
                >
                  <div className="sign-in-your mt-3 " style={{ width: "90%" }}>
                    <div className="row d-flex justify-content-center">
                      <img
                        src={logo}
                        style={{ width: "150px", cursor: "pointer" }}
                        alt=""
                      />
                    </div>

                    <div className="row mt-4">
                      <span
                        className="login-title"
                        style={{ textAlign: "center", fontWeight: "600" }}
                      >
                        Set Password For New User
                      </span>
                    </div>
               <div className="row mt-4">
                      <div>
                        <PasswordField
                          inputValue={password}
                          labelName={"New Password"}
                          errorOccured={passwordError}
                          errorMessage={""}
                          onChange={(e) => {
                            e.target.value = e.target.value.toString();
                            //.slice(0, 12)
                            setPasswordError(false);
                            setPassword(e.target.value);
                          }}
                        />
                        <PasswordField
                          inputValue={confirmPassword}
                          labelName={"Confirm Password"}
                          errorOccured={confirmPasswordError}
                          errorMessage={"Password does not match "}
                          onChange={(e) => {
                            e.target.value = e.target.value.toString();
                            //.slice(0, 12)
                            if (
                              confirmPasswordValidation(
                                password,
                                e.target.value
                              )
                            ) {
                              setConfirmPasswordError(false);
                            } else {
                              setConfirmPasswordError(true);
                            }
                            setConfirmPassword(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <PrimaryButton
                      buttonName={"Set Password"}
                      type={"submit"}
                      isLoading={loadingActive}
                      loadingMessage={"Loading..."}
                      style={{
                        width: "100%",
                      }}
                      onClick={onSubmit}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SetPasswordForNewUser;
